/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SearchCompanyResponse as ModelsSearchCompanyResponse } from '../../models/models/search-company-response';

export interface ApiV1BorCompaniesSearchGet$Params {

/**
 * Search term
 */
  searchTerm: string;

/**
 * Page number
 */
  page?: number;

/**
 * Page size
 */
  size?: number;
}

export function apiV1BorCompaniesSearchGet(http: HttpClient, rootUrl: string, params: ApiV1BorCompaniesSearchGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsSearchCompanyResponse>> {
  const rb = new RequestBuilder(rootUrl, apiV1BorCompaniesSearchGet.PATH, 'get');
  if (params) {
    rb.query('searchTerm', params.searchTerm, {});
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsSearchCompanyResponse>;
    })
  );
}

apiV1BorCompaniesSearchGet.PATH = '/api/v1/bor/companies/search';
